import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../api/client";

const styles = {
  page: { padding: 10, fontSize: 11 },
  card: {
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 2px 10px rgba(0,0,0,.08)",
    overflow: "hidden",
  },
  header: {
    background: "linear-gradient(90deg, #22052D, #CCB3D1)",
    color: "#fff",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
  },
  title: { fontSize: 13, fontWeight: 700 },
  sub: { fontSize: 10, opacity: 0.85 },
  body: { padding: 10 },
  btn: {
    height: 30,
    fontSize: 11,
    borderRadius: 7,
    fontWeight: 600,
    padding: "4px 10px",
  },
  tableWrap: {
    overflowX: "auto",
    border: "1px solid #e9ecef",
    borderRadius: 10,
  },
  table: {
    fontSize: 11,
    marginBottom: 0,
    minWidth: 950,
  },
  th: {
    fontSize: 10,
    padding: "7px 8px",
    color: "#fff",
    whiteSpace: "nowrap",
  },
  td: {
    fontSize: 11,
    padding: "7px 8px",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
};

export default function InvoiceTemplateListPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const res = await client.get("/invoice-templates");
      setTemplates(Array.isArray(res.data) ? res.data : []);
    } catch {
      alert("Failed to load templates");
    } finally {
      setLoading(false);
    }
  };

  const setDefault = async (id) => {
    try {
      await client.post(`/invoice-templates/${id}/set-default`);
      loadTemplates();
    } catch {
      alert("Failed to set default template");
    }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm("Delete this template?")) return;

    try {
      await client.delete(`/invoice-templates/${id}`);
      loadTemplates();
    } catch {
      alert("Failed to delete template");
    }
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div>
            <div style={styles.title}>
              <i className="bi bi-layout-text-window-reverse me-2"></i>
              Invoice Templates
            </div>

            <div style={styles.sub}>
              Create, manage and customize invoice layouts
            </div>
          </div>

          <Link
            to="/invoice-templates/designer"
            className="btn btn-light btn-sm"
            style={styles.btn}
          >
            <i className="bi bi-plus-circle me-1"></i>
            Create Template
          </Link>
        </div>

        <div style={styles.body}>
          <div
            style={{
              fontSize: 10,
              color: "#6c757d",
              marginBottom: 6,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              Templates: <strong>{templates.length}</strong>
            </span>

            <span>Default template highlighted in green</span>
          </div>

          <div style={styles.tableWrap}>
            <table
              className="table table-bordered table-hover align-middle"
              style={styles.table}
            >
              <thead>
                <tr>
                  <th style={styles.th}>Template Name</th>
                  <th style={styles.th}>Default</th>
                  <th style={styles.th}>Created Date</th>
                  <th style={{ ...styles.th, minWidth: 320 }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center text-muted"
                      style={{ ...styles.td, padding: 18 }}
                    >
                      Loading...
                    </td>
                  </tr>
                ) : templates.length === 0 ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center text-muted"
                      style={{ ...styles.td, padding: 18 }}
                    >
                      No templates found
                    </td>
                  </tr>
                ) : (
                  templates.map((x) => (
                    <tr key={x.templateId}>
                      <td style={{ ...styles.td, fontWeight: 700 }}>
                        {x.templateName}
                      </td>

                      <td style={styles.td}>
                        {x.isDefault ? (
                          <span
                            className="badge bg-success"
                            style={{ fontSize: 10 }}
                          >
                            Default
                          </span>
                        ) : (
                          <span
                            className="badge bg-secondary"
                            style={{ fontSize: 10 }}
                          >
                            No
                          </span>
                        )}
                      </td>

                      <td style={styles.td}>
                        {x.createdDate
                          ? new Date(x.createdDate).toLocaleDateString("en-IN")
                          : ""}
                      </td>

                      <td style={styles.td}>
                        <div className="d-flex flex-wrap gap-1">
                          <Link
                            to={`/invoice-templates/designer/${x.templateId}`}
                            className="btn btn-warning btn-sm"
                            style={styles.btn}
                          >
                            <i className="bi bi-pencil-square me-1"></i>
                            Edit
                          </Link>

                          <Link
                            to={`/invoice-templates/print/${x.templateId}`}
                            className="btn btn-info btn-sm text-white"
                            style={styles.btn}
                          >
                            <i className="bi bi-eye me-1"></i>
                            Preview
                          </Link>

                          {!x.isDefault && (
                            <button
                              className="btn btn-success btn-sm"
                              style={styles.btn}
                              onClick={() => setDefault(x.templateId)}
                            >
                              <i className="bi bi-check-circle me-1"></i>
                              Default
                            </button>
                          )}

                          <button
                            className="btn btn-danger btn-sm"
                            style={styles.btn}
                            onClick={() => deleteTemplate(x.templateId)}
                          >
                            <i className="bi bi-trash me-1"></i>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
